/**
 * @fileOverview Footer
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Local:collapse
 * @requires Local:scroll-to-header
 */

import Collapse from './collapse';
import initScrollToHeader from './scroll-to-header';

/**
* Init footer js
*/
export default function initFooter() {
  new Collapse();
  initScrollToHeader();
}
